/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListAlertTemplates {
    getFixupPrototypeFunction() { return ListAlertTemplates.fixupPrototype; }

    static newInstance(model: Partial<ListAlertTemplates>): ListAlertTemplates {
        let obj = Object.assign(new ListAlertTemplates(), model);
        ListAlertTemplates.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListAlertTemplates>): ListAlertTemplates {
        if (!model) return null;
        return ListAlertTemplates.newInstance(<ListAlertTemplates> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListAlertTemplates) {
        if (!obj) return;

        models.ListAlertTemplates.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListAlertTemplates): boolean {
        Object.setPrototypeOf(obj, ListAlertTemplates.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
    }

    /**
     * total records count
     */
    total_count: number;

    /**
     * Count of number of pages
     */
    page_count: number;

    metric_alert_templates: Array<any>;

}
